<template>
  <button
    class="information-toggle-button-parts"
    :class="{
      'information-toggle-button-parts--hidden': !hasCurrentRaceInformation,
      'information-toggle-button-parts--is-open': showInformation,
    }"
    @click="emitClick"
  >
    <span>{{ $tc('RaceListPage.Information.RaceKeyPoints') }}</span>
    <i>
      <svg
        :class="{ 'is-stop': stopIconBounds }"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.40317 3.71814L4.20343 7.91789L2.08211 7.91789L3.14277 6.85723L8.44607 1.55393C8.83659 1.16341 9.46976 1.16341 9.86028 1.55393L15.1636 6.85723L16.2242 7.91789L14.1029 7.91789L9.90317 3.71814L9.90318 16.4032L8.40318 16.4032L8.40317 3.71814Z"
          fill="black"
        />
      </svg>
    </i>
  </button>
</template>

<script lang="ts">
import { defineComponent, ref } from '@vue/composition-api'

/**
 * レース一覧画面: Race Information 開閉ボタン
 */
export default defineComponent({
  name: 'InformationToggleButtonParts',
  props: {
    /**
     * Information
     */
    hasCurrentRaceInformation: {
      type: Boolean,
      default: true,
    },
    /**
     * Information 部開閉フラグ
     */
    showInformation: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const stopIconBounds = ref<boolean>(false)
    return {
      stopIconBounds,
    }
  },
  methods: {
    /**
     * Click通知
     */
    emitClick(): void {
      this.$emit('click')

      if (!this.stopIconBounds) {
        this.stopIconBounds = true
      }
    },
  },
})
</script>

<style lang="scss" scoped>
@keyframes boundIcon {
  0%,
  30%,
  60%,
  100% {
    transform: translateY(0);
  }

  15%,
  45% {
    transform: translateY(-50%);
  }
}

.information-toggle-button-parts {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 44px;
  gap: 4px;
  font-weight: 600;
  font-size: min(#{convertPXtoVW(16)}, 16px);
  line-height: 1.38;
  text-align: center;
  letter-spacing: 0.04em;

  svg {
    display: block;
    animation: boundIcon 1.5s linear 1s 3;

    &.is-stop {
      animation: none;
    }
  }

  &--hidden {
    display: none;
  }

  &--is-open {
    svg {
      transform: rotate(180deg);
    }
  }
}
</style>
